<template>
    <div style="margin-top: 60px">
      <media :query="{maxWidth: 900}">
        <div>
          <router-link to="/scan" class="navlink"> Scan </router-link>
          <div style="height: 10px"></div>
          <router-link to="/mOrder" class="navlink"> Order </router-link>
          <div style="height: 10px"></div>
          <a class="navLink" v-if="showFacility" v-on:click="modalChangeFacility = 1" style="cursor: pointer; color: #000; padding-right: 25px;margin-top: 5%;"> Facility </a>
        </div>
      </media>

      <media :query="{minWidth: 900}"> 
      <div style="display: flex; flex-direction: row; justify-content: center; padding-bottom: 4%;">
        <router-link to="/allItems" class="navlink" style="color: #036D69"> Inventory </router-link>
        <router-link to="/orders" class="navlink"> Order History </router-link>
        <a class="navLink" v-on:click="showCart" style="cursor: pointer; color: #1279B7; padding-right: 25px;"> Cart </a>
        <a class="navLink" v-if="showFacility" v-on:click="modalChangeFacility = 1" style="cursor: pointer; color: #000; padding-right: 25px;"> Facility </a>
        <router-link to="/settings" v-if="showSettings" class="navlink"> Settings </router-link>
        <router-link to="/login" class="navlink"> Log Out </router-link>
      </div> 
      </media>    
      
      <media :query="{minWidth: 900}">
      <div style=" display: flex; flex-direction: row; justify-content: center; align-items: center">
      <div style="margin-right: 145px">
      </div>
      <div>
        <img src="https://i.imgur.com/Az6Xs7i.png" style="width: 400px; height: 300px; padding-right: 25px; padding-left: 50px;">
        <div>
         <!-- <h1 style="margin: 0; padding: 0;"> Display a message </h1> -->
        </div>
      </div>
      <div class="speech-bubble" style="margin-bottom: 300px">
        <p style="margin-bottom: 0; padding-bottom: 5px;">Hey <span>{{$store.state.name}},</span> you are currently ordering for: </p>
        <span style="margin: 0; padding: 0; font-weight: 900">{{orderLocation}}</span>
      </div>
      </div>
      </media>

      <media :query="{minWidth: 900}">
          <h1 style="padding-bottom: 0px; margin-bottom: 0px"> The Next Delivery Will Be On: <span>{{deliveryDate}}</span></h1>
      </media>

      <!-- <media :query="{minWidth: 900}">
          <div>
          <h1 style="padding-bottom: 0px; margin-bottom: 0px"> The Next Delivery Will Be On: <span>Monday: 12/28</span></h1>
          <h2> Happy Holidays everyone!</h2>
          </div>
      </media> -->

      <media :query="{minWidth: 900}">
      <div style="display: flex; flex-direction: row; justify-content: center">
          <div style="display: flex; flex-direction: column; padding-right: 10px">
              <h1 class="timeDisplay" v-bind:style="displayHours < 3 && displayDays < 1? {'color' : '#FF9B9B'} : {'color' : '#2c3e50'}">{{displayDays}} <span> : </span></h1>
              <h6 v-if="displayDays > 1"  style="padding: 0px; margin: 0px; padding-right: 40px"> Days </h6>
              <h6 v-else style="padding: 0px; margin: 0px; padding-right: 40px"> Day </h6>
          </div>

          <div style="display: flex; flex-direction: column; padding-right: 10px">
              <h1 class="timeDisplay" v-bind:style="displayHours < 3 && displayDays < 1? {'color' : '#FF9B9B'} : {'color' : '#2c3e50'}">{{displayHours}} <span> : </span></h1>
              <h6 v-if="displayHours > 1" style="padding: 0px; margin: 0px; padding-right: 40px"> Hours </h6>
              <h6 v-else style="padding: 0px; margin: 0px; padding-right: 40px"> Hour </h6>
          </div>

          <div style="display: flex; flex-direction: column; padding-right: 10px">
              <h1 class="timeDisplay" v-bind:style="displayHours < 3 && displayDays < 1? {'color' : '#FF9B9B'} : {'color' : '#2c3e50'}">{{displayMinutes}} <span> : </span></h1>
              <h6 v-if="displayMinutes > 1" style="padding: 0px; margin: 0px; padding-right: 40px"> Minutes </h6>
              <h6 v-else style="padding: 0px; margin: 0px; padding-right: 40px"> Minute </h6>
          </div>

          <div style="display: flex; flex-direction: column; padding-right: 10px">
              <h1 class="timeDisplay" v-bind:style="displayHours < 3 && displayDays < 1? {'color' : '#FF9B9B'} : {'color' : '#2c3e50'}">{{displaySeconds}} </h1>
              <h6 v-if="displaySeconds > 1"  style="padding: 0px; margin: 0px; padding-right: 2px"> Seconds </h6>
              <h6 v-else style="padding: 0px; margin: 0px; padding-right: 40px"> Second </h6>
          </div>
      </div>
      </media>
      

<!--//////////////////////////////////////////// Cart Model///////////////////////////////////////////////////////// -->

<transition name="modal">
<div v-if="modal2" class="modal-mask">
  <div class="modal-wrapper">
    <div class="modal-container">

      <div class="modal-header">
        <slot name="header">
          <!-- <h3 style="margin: 0px; padding: 0px; background-color: #9CDDD9; border: solid 2px #9CDDD9; width: 100%">{{displayProdName}}<span v-on:click="displayDetails = 0" style="color: #FFF; float: right; cursor: pointer; padding-right: 2%">X</span></h3> -->
          <div style="display: flex; flex-direction: row;">
            <h2 class="modal-banner">Your Cart
              <span v-on:click="closeCart" style="color: #FFF; float: right; cursor: pointer; padding-right: 2%">X</span> 
            </h2>
            <!-- <button v-on:click="closeCart" class="cancelButton" style="padding-right: 3%"> X </button> -->
          </div>
        </slot>
      </div>

      <transition name="slide">
      <div v-if="doubleAlert" style="margin-bottom: 2%; box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19); margin-top: 2%">
      <div style="display: flex; flex-direction: row">
          <h3 style="margin: 0px; padding: 0px; background-color: #FF9B9B; border: solid 2px #FF9B9B; width: 100%; color: #FFF"> Double Entry? <span v-on:click="doubleAlert = 0" style="color: #FFF; float: right; cursor: pointer; padding-right: 2%">X</span> </h3>
      </div>
        <div style="display: flex; flex-direction: column; justify-content: center; align-items: center">
          <h2> The following items have already been ordered: </h2>
          <div>
                <tr>
                    <th> Name </th>
                    <th> Amount </th>
                    <th> Comment </th>
                    <th> Ordered By </th>
                    <th> Remove </th>
                <tr v-for="item in prevOrder" :key="item.custom">
                    <td>{{item.name}}
                    <td>{{item.amount}}</td>
                    <td>{{item.comment}}</td>
                    <td>{{item.orderedBy}}</td>
                    <td><input type="checkbox" :value="item" v-model="cancelForm"></td>
                </tr>
          </div>
        </div>
        
        <div style="padding-top: 1%; padding-bottom: 1%">
            <button style="margin-right: 1%; background-color: #8CB6D2" v-on:click="removeFromOrder"> Remove </button>
            <button style="background-color: #9CDDD9" v-on:click="doubleAlert = 0"> Ignore </button>
        </div>
      </div>
      </transition>

      <div class="modal-body" v-if="modal3">
        <slot name="body">
            <div>
            <table>
                <tr>
                    <th> Name </th>
                    <th> Amount </th>
                    <th> On Hand </th>
                    <th> Check </th>
                    <th> Comment </th>
                <tr v-for="item in this.$store.state.shoppingCart" :key="item.custom">
                    <td>{{item.name}}
                    <td>{{item.amount}}</td>
                    <td v-if="item.onhand" v-bind:style="item.cur >= item.onhand? {'color' : '#07ABA1' } : {'color' : '#ff9b9b'}">{{item.cur}} <span style="color: #000">/</span> <span style="color: #000"> {{item.onhand}}</span></td>
                    <td v-else style="color: #CDEEEC"> N/A </td>
                    <td> <span v-if="item.cur + item.amount >= item.onhand || !item.onhand" style="color: #07ABA1">&#x2713;</span>
                         <span v-else style="color: #ff9b9b; font-weight: bold;"> X </span>
                    </td>
                    <td>{{item.comment}}</td>
                </tr>
            </table>
            </div>
        </slot>
      </div>

      <div class="modal-body" v-if="modal4">
        <slot name="body">
            <div style="padding: 5px;">
            <h3 style="color: #ff9b9b; margin: 0px 0px 10px 0px;">{{msg}}</h3>
            <table>
                <tr>
                    <th> Name </th>
                    <th> On Hand </th>
                    <th> Order Amount </th>
                    <th> Add Details </th>
                    <th> Remove</th>
                </tr>
                <tr v-for="product in orderForm">
                    <td v-if="product.name.length > 1">{{product.name}}</td>
                    <td v-else><input type="text" style="width: 200px; border: solid lightgrey 1px" v-on:change="onCustomChangeCart(product.custom, $event)"/></td>
                    <td v-if="product.onhand"v-bind:style="product.cur > product.onhand? {'color' : '#07ABA1' } : {'color' : '#ff9b9b'}">{{product.cur}} <span style="color: #000">/</span> <span style="color: #000"> {{product.onhand}}</span></td>
                    <td v-else> N/A </td>
                    <td><input type="number" name="amount" min="1" style="width: 50px; border: lightgrey solid 1px;" v-on:input="onChangeCart(product.name, $event)" :placeholder="product.amount"/></td>
                    <td><button style="width: 25px; height: 25px; padding: 2px;" v-on:click.stop.prevent="createDetails(product)">+</button> </td>
                    <td><button style="width: 25px; height: 25px; padding: 2px; background-color: #FF9b9b" v-on:click.stop.prevent="onRemove(product.custom, $event)">x</button></td>
                </tr>
            </table>
            <button v-on:click.stop.prevent="insertProd" style="background-color: #9CDDD9; margin-right: 5px;"> Custom </button>
            <button style="margin-top: 2%; background-color: #07ABA1" v-on:click="updateCart"> Update Cart </button>
            </div>
        </slot>
      </div>

      <div class="modal-body" v-if="modal5">
        <slot name="body">
            <div v-if="customItemFlag">
                <h2> Do you want to add any of the following custom items to your inventory? </h2>
                <table>
                    <tr>
                        <th> Name </th>
                        <th> Yes </th>
                    <tr v-for="(item, i) in customItems" :key="i">
                        <td>{{item.name}}</td>
                        <td><input type="checkbox" :value="item" v-model="customForm"> </td>
                    </tr>
                </table>
                <div style="padding-top: 2%">
                    <button style="margin-right: 5px" v-on:click="fbAddInventory"> Add to Inventory </button>
                    <button v-on:click="cancelAddInventory"> No Need </button>
                </div>
            </div>
            <div v-else>
                <h1> Your order has been successfully registered! </h1>
                <h2> We will contact you if there are any problems</h2>
                <table>
                    <tr>
                        <th> Name </th>
                        <th> Amount </th>
                        <th> Comment </th>
                    <tr v-for="item in this.$store.state.shoppingCart" :key="item.custom">
                        <td>{{item.name}}
                        <td>{{item.amount}}</td>
                        <td>{{item.comment}}</td>
                    </tr>
                </table>
            </div>
        </slot>
      </div>

      <div class="modal-footer" v-if="!modal4 && !modal5">
        <slot name="footer">
          <button v-if="!emergencyFlag" class="modal-default-button" v-on:click="emergencyFlag = 1" style="background-color: #FF9B9B;"> Urgent </button>
          <button v-else class="modal-default-button" v-on:click="emergencyFlag = 0" style="background-color: red;"> Urgent </button>
          <button class="modal-default-button" v-on:click="clearCart" style="background-color: #8CB6D2;"> Clear Cart </button>
          <button class="modal-default-button" v-on:click="editCart" style="background-color: #9CDDD9;"> Edit Cart </button>
          <button class="modal-default-button" v-on:click="submitCart"> Submit </button>
        </slot>
      </div>
    </div>
  </div>
</div>
</transition>

<!---//////////////////////////////////  Add Link to Order Model //////////////////////////////////// -->


<transition name="modal">
<div v-if="modalAdditionalInfo" class="modal-mask">
  <div class="modal-wrapper">
    <div class="modal-container" style="width: 450px; height: 500px; overflow-y: hidden;">
      <div class="modal-header">
        <slot name="header">
          <div style="display: flex; flex-direction: row;">
            <h2 class="modal-banner">{{currentItem.name}}</h2>
          </div>
        </slot>
      </div>

      <div class="modal-body">
        <slot name="body">
            <div class="form-style-7">
            <ul>
            <li>
                <label for="comment">Comment</label>
                <input type="text" name="name" maxlength="100" v-on:input="addDetails(currentItem, $event, 'comment')" :placeholder="currentItem.comment">
                <span>Enter a comment</span>
            </li>
            <li>
                <label for="manufacturer">Manufacturer</label>
                <input type="text" name="manufacturer" maxlength="100" v-on:input="addDetails(currentItem, $event, 'manu')" :placeholder="currentItem.manufacturer">
                <span>Enter a manufacturer (eg: OpenSprinklr)</span>
            </li>
            <li>
                <label for="part">Part No.</label>
                <input type="text" name="part" maxlength="100" v-on:input="addDetails(currentItem, $event, 'part')" :placeholder="currentItem.part">
                <span>Enter a part number (if applicable)</span>
            </li>
            <li style="display: block; padding: 9px; border: 1px solid #ddd; margin-bottom: 30px; border-radius: 3px">
                <label for="link">Link</label>
                <textarea name="link" v-on:input="addDetails(currentItem, $event, 'link')" :placeholder="currentItem.productLink"></textarea>
                <span>Enter a link for the product</span>
            </li>
            </ul>
              <button class="modal-default-button" style="width: 65px"  v-on:click="modalAdditionalInfo = 0"> Update </button>
              <button class="modal-default-button" style= "width: 65px; background-color: #8CB6D2;" v-on:click="modalAdditionalInfo = 0"> Cancel </button>
            </div>
        </slot>
      </div>

      <div class="modal-footer" v-if="!modal4 && !modal5">
        <slot name="footer">
        </slot>
      </div>
    </div>
  </div>
</div>
</transition>

<!---//////////////////////////////////  Change Facility Model //////////////////////////////////// -->


      <transition name="modal">
      <div v-if="modalChangeFacility" class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container" style="width: 70%; height: 150px; overflow-y: hidden;">
            <div class="modal-header">
              <slot name="header">
                <div style="display: flex; flex-direction: row;">
                  <h2 class="modal-banner">Change Facility
                    <span v-on:click="modalChangeFacility = 0" style="color: #FFF; float: right; cursor: pointer; padding-right: 2%">X</span> 
                  </h2>
                  <!-- <button v-on:click="modalChangeFacility = 0" class="cancelButton" style="padding-right: 5%; border: none"> X </button> -->
                </div>
              </slot>
            </div>

            <div class="modal-body">
              <slot name="body">
                  <div>
                      <div>
                          <h3> Select a Facility</h3>
                          <select v-on:change="changeFacility()" v-model="selectedFacility">
                            <option> Select a Facility </option>
                            <option v-for="(facility, i) in accProfile[0].additional" v-bind:id="i">
                              {{facility}}
                            </option>
                          </select>
                      </div>
                  </div>
              </slot>
            </div>

            <div class="modal-footer">
              <slot name="footer">
              </slot>
            </div>
          </div>
        </div>
      </div>
      </transition>

    </div>
</template>

<script>
    import Media from 'vue-media'

    export default {
        components: {
          Media
        },
        created() {
            this.$store.dispatch('getUserInfo').then(res => {
                this.$store.state.userProfile = res
                this.accProfile = res
            })
        },
        mounted() {
            this.showRemaining()
            this.$store.dispatch('getUserInfo').then(res => {
                this.$store.state.userProfile = res
                if(this.accProfile[0].additional){
                  this.showFacility = 1
                }
                if(this.accProfile[0].title === 'ADS'){
                  this.showSettings = 1
                }
                this.orderLocation = this.$store.state.orderLocation
                if(this.orderLocation === 'w3') {
                  this.orderLocation = 'OVP'
                }
            })
            console.log(this.$store.state.userProfile)
        },
        data () {
            return {
                displayDays: 0,
                displayHours: 0,
                displayMinutes: 0,
                displaySeconds: 0,
                deliveryDate: '',
                selectedFacility: '',
                showFacility: 0,
                showSettings: 0,
                user: '',
                modalChangeFacility: 0,
                accProfile: this.$store.state.userProfile,
                shoppingCart: this.$store.state.shoppingCart,
                ///////////////////////////////////
                customForm: [],
                customItems: [],
                customItemFlag: 0,
                allStock: [],
                searchTable: {},
                searchNames: [],
                allStock: [],
                stockTable: {},
                stock: [],
                /////// implementing cart /////////
                currentItem: {},
                modal2: 0,
                modal3: 0,
                modal4: 0,
                modal5: 0,
                flag1: 0,
                flag2: 0,
                order: [],
                orderForm: [],
                modalAdditionalInfo: 0,
                ///////////////////////////////////
                prevOrder: {},
                cancelForm: [],
                cancelDict: {},
                doubleAlert: 0,
                msg: '',
                ///////////////////////////////////
                orderLocation: '',
                emergencyFlag: 0,
            }
        },
        computed: {
              _seconds: () => 1000,
              _minutes(){
                  return this._seconds * 60
              },
              _hours(){
                  return this._minutes * 60
              },
              _days(){
                  return this._hours * 24
              }
        },
        methods: {
///////////////////////////////////////////////////////// Timer Functions ////////////////////////////////////////////////////////////////////
            showRemaining(){
              const timer = setInterval(()=> {
                    let now = new Date();
                    let month = now.getMonth()
                    let year = now.getFullYear()
                    let day = now.getDate()
                    let end_day = now.getDate()
                    let end_hour = 15
                    if (now.getHours() > 15){
                      day = now.getDate() + 1
                    }
                    //check if the next delivery date falls on the start of the month
                    //!!! Review this at the last week of September
                    if(day === this.findLastDay(year, month)){
                        month = month + 1
                        day = 1
                    }
                    
                    //figure out the next delivery date
                    switch (now.getDay()) {
                      // Sunday
                      case 0:
                        let d = new Date()
                        d.setDate(d.getDate() + 2)
                        this.deliveryDate = 'Tuesday  ' + (d.getMonth() + 1) + '/' + d.getDate()
                        end_day = now.getDate() + 1
                        end_hour = 15
                        break
                      // Monday
                      case 1:
                        // d = new Date()
                        // d.setDate(d.getDate() + 1)
                        // if(d.getHours() < 15){
                        //   this.deliveryDate = 'Tuesday ' + (d.getMonth() + 1) + '/' + d.getDate()
                        //   end_hour = 15
                        // } else {
                        //   d.setDate(d.getDate() + 2)
                        //   this.deliveryDate =  'Thursday  ' + (d.getMonth() + 1) + '/' + d.getDate()
                        //   end_day = now.getDate() + 2
                        // }
                        // break
                        d = new Date()
                        if(d.getHours() < 15){
                            if(d.getDate() === this.findLastDay(d.getFullYear(), d.getMonth())){
                                this.deliveryDate = 'Tuesday ' + (d.getMonth() + 2) + '/' + 1
                                end_day = d.getDate() - this.findLastDay(d.getFullYear(), d.getMonth())
                                end_hour = 15
                            } else {
                                d.setDate(d.getDate() + 1)
                                if(d.getHours() < 15) {
                                this.deliveryDate = 'Tuesday ' + (d.getMonth() + 1) + '/' + d.getDate()
                                end_hour = 15
                                }
                            }
                        } else {
                          d.setDate(d.getDate() + 2)
                          this.deliveryDate =  'Thursday  ' + (d.getMonth() + 1) + '/' + (d.getDate() + 1)
                          end_day = now.getDate() + 2
                        }
                        break
                      // Tuesday
                      case 2:
                        // d = new Date()
                        // d.setDate(d.getDate() + 1)
                        // this.deliveryDate = 'Thursday  ' + (d.getMonth() + 1) + '/' + d.getDate()
                        // end_day = now.getDate() + 1
                        // end_hour = 15
                        d = new Date()
                        if(d.getDate() === this.findLastDay(d.getFullYear(), d.getMonth())){
                            this.deliveryDate = 'Thursday ' + (d.getMonth() + 2) + '/' + 2
                            end_day = d.getDate() - (this.findLastDay(d.getFullYear(), d.getMonth()) + 1)
                            end_hour = 15
                        } else {
                            d.setDate(d.getDate() + 1)
                            this.deliveryDate = 'Thursday  ' + (d.getMonth() + 1) + '/' + (d.getDate() + 1)
                            end_day = now.getDate() + 1
                            end_hour = 15
                        }                        
                        break
                      // Wednesday
                      case 3:
                        d = new Date()
                        if(d.getHours() < 15){
                            if(d.getDate() === this.findLastDay(d.getFullYear(), d.getMonth())){
                                this.deliveryDate = 'Thursday ' + (d.getMonth() + 2) + '/' + 1
                                end_day = d.getDate() - this.findLastDay(d.getFullYear(), d.getMonth())
                                end_hour = 15
                            } else {
                              this.deliveryDate = 'Thursday ' + (d.getMonth() + 1) + '/' + (d.getDate() + 1)
                              end_day = d.getDate() 
                              console.log("end_day is: " + end_day)
                              end_hour = 15
                            }
                        } else {
                          // d.setDate(d.getDate() + 1)
                          // this.deliveryDate =  'Friday  ' + (d.getMonth() + 1) + '/' + d.getDate()
                          // end_day = now.getDate() + 1
                          if(d.getDate() === this.findLastDay(d.getFullYear(), d.getMonth())){
                              this.deliveryDate = 'Friday ' + (d.getMonth() + 2) + '/' + (d.getDate() - (this.findLastDay(d.getFullYear(), d.getMonth())) + 2)
                              d.setDate(d.getDate() - (this.findLastDay(d.getFullYear(), d.getMonth())) + 1)
                              end_day = now.getDate() + 1
                          } else {
                              d.setDate(d.getDate() + 1)
                              this.deliveryDate =  'Friday  ' + (d.getMonth() + 1) + '/' + (d.getDate() + 1)
                              end_day = now.getDate() + 1                           
                          }
                        }
                        break
                      // Thursday
                      case 4:
                        d = new Date()
                        if(d.getHours() < 15){
                            d.setDate(d.getDate() + 1)
                            this.deliveryDate =  'Friday  ' + (d.getMonth() + 1) + '/' + d.getDate()
                            end_day = now.getDate()
                        } else {
                            // d.setDate(d.getDate() + 4)
                            // this.deliveryDate =  'Tuesday  ' + (d.getMonth() + 1) + '/' + (d.getDate() + 4)
                            // end_day = now.getDate() + 4
                            // end_hour = 15
                            d.setDate(d.getDate() + 5)
                            this.deliveryDate =  'Tuesday  ' + (d.getMonth() + 1) + '/' + (d.getDate())
                            end_day = now.getDate() + 4
                            end_hour = 15
                        }
                        break
                      // Friday
                      case 5:
                        d = new Date()
                        // d.setDate(d.getDate() + 1)
                        // this.deliveryDate = 'Tuesday  ' + (d.getMonth() + 1) + '/' + (d.getDate() + 3)
                        // end_day = now.getDate() + 3
                        // end_hour = 15
                        d.setDate(d.getDate() + 4)
                        this.deliveryDate = 'Tuesday  ' + (d.getMonth() + 1) + '/' + (d.getDate())
                        end_day = now.getDate() + 3
                        end_hour = 15
                        break
                      // Saturday
                      case 6:
                        d = new Date()
                        // d.setDate(d.getDate() + 1)
                        // this.deliveryDate = 'Tuesday  ' + (d.getMonth() + 1) + '/' + (d.getDate() + 2)
                        // end_day = now.getDate() + 2
                        // end_hour = 15
                        d.setDate(d.getDate() + 3)
                        this.deliveryDate = 'Tuesday  ' + (d.getMonth() + 1) + '/' + (d.getDate())
                        end_day = now.getDate() + 2
                        end_hour = 15
                        break
                    }
                    
                    let end = new Date(year, month, end_day, end_hour, 0, 0, 0)
                    let distance = end.getTime() - now.getTime()

                    if(distance < 0){
                        clearInterval(timer);
                        return
                    }

                    const days = Math.floor(distance / this._days)
                    const hours = Math.floor((distance % this._days) / this._hours)
                    const minutes = Math.floor((distance % this._hours) / this._minutes)
                    const seconds = Math.floor((distance % this._minutes) / this._seconds)
                    this.displaySeconds = seconds < 10 ? "0" + seconds : seconds
                    this.displayMinutes = minutes < 10 ? "0" + minutes : minutes
                    this.displayHours = hours < 10 ? "0" + hours : hours
                    this.displayDays = days < 10 ? "0" + days : days
                }, 1000)
            },
            findLastDay(year, month){
              return new Date(year, month + 1, 0).getDate()
            },
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            changeFacility() {
                console.log("we are in change facility")
                console.log(this.selectedFacility)
                this.$store.state.userProfile[0].title = this.selectedFacility
                this.$store.dispatch('setFacility', this.selectedFacility).then(res => {
                    this.modalChangeFacility = 0  
                    this.orderLocation = this.selectedFacility
                    if(this.orderLocation === 'w3') {
                      this.orderLocation = 'OVP'
                    }
                })
            },
////////////////////////////////////////////////// Ordering Functions /////////////////////////////////////////////////////////////////////
              generateHash(el, arr){
                let newObject = {'name': '', 
                                 'amount' : '',  
                                 'cur' : '', 
                                 'onhand' : '', 
                                 'comment' : '', 
                                 'custom' : '',
                                 'isCustom' : '', 
                                 'ADSitem' : '',
                                 'status' : '',
                                 'adsComment' : '',
                                 'productLink' : '',
                                 'manufacturer' : '',
                                 'part' : '',
                                 'orderDate': '',
                                 'orderedBy' : '',
                                 }
                    newObject['name'] = el.name
                    newObject['cur'] = el.cur
                    newObject['onhand'] = el.onhand
                    newObject['isCustom'] = el.isCustom
                    newObject['ADSitem'] = el.ADSitem
                    newObject['custom'] = el.custom
                    newObject['status'] = el.status
                    newObject['productLink'] = el.productLink
                    newObject['manufacturer'] = el.manufacturer
                    newObject['part'] = el.partNo
                    newObject['orderDate'] = el.orderDate
                    newObject['orderedBy'] = el.orderedBy
                    arr.push(newObject)
              },
              checkForm() {
                console.log('is this where the error is occuring?')
                if(!this.accProfile){
                    this.$store.dispatch('getUserInfo').then(res => {
                        this.$store.state.userProfile = res
                    })
                }
                this.flag1 = 0
                this.flag2 = 1
                let temp = []
                for(let i = 0; i < this.orderForm.length; i++) {
                    let newObject = {'name' : this.orderForm[i].name,
                                     'cur' : this.orderForm[i].quantity,
                                     'onhand': this.orderForm[i].necessary_amount,
                                     'quantity' : this.orderForm[i].quantity,
                                     'isCustom' : this.orderForm[i].isCustom,
                                     'ADSitem' : this.orderForm[i].ADSitem,
                                     'custom' : this.createRand(),
                                     'status' : 0,
                                     'adsComment' : '',
                                     'productLink' : this.orderForm[i].productLink,
                                     'manufacturer' : this.orderForm[i].manufacturer,
                                     'part' : this.orderForm[i].partNo,
                                     'orderDate' : new Date(),
                                     'orderedBy' : this.accProfile[0].name
                                    }
                    temp.push(newObject)
                }
                this.orderForm = temp
                this.orderForm.forEach(el =>
                    this.generateHash(el, this.order)
                );
              },
              cancelOrderForm(){
                  this.flag2 = 0
                  this.flag1 = 1
                  this.orderForm =[]
              },
              createRand() {
                  return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
              },
              insertProd(e){
                  e.preventDefault()
                  let newObject = {'name' : '', 
                                   'amount' : '', 
                                   'cur': '', 
                                   'onhand' : '', 
                                   'comment' : '', 
                                   'isCustom' : 1,
                                   'ADSitem' : 0,
                                   'custom' : this.createRand(), 
                                   'status' : 0, 
                                   'adsComment' : '',
                                   'productLink' : '',
                                   'manufacturer' : '',
                                   'part' : '',
                                   'orderDate' : new Date(),
                                   'orderedBy': this.accProfile[0].name}
                  this.orderForm.push(newObject)
                  this.order.push(newObject)
              },
              onChange(str, event){
                  if(event.target.value < 1){
                      this.msg = "A invalid amount has been typed for " + str
                  }
                  else {
                  this.msg = ''
                      for (let i = 0; i < this.order.length; i++){
                            if(this.order[i].name === str){
                              this.order[i].amount = event.target.value
                          }
                      }
                  }
              },
              onTextChange(str, event){
                  for (let i = 0; i < this.order.length; i++){
                        if(this.order[i].name === str){
                          this.order[i].comment = event.target.value
                      }
                  }
              },
              onCustomChange(id, event) {
                  event.preventDefault()
                  console.log("item id is: " + id)
                  for (let i = 0; i < this.order.length; i++) {
                      if(id === this.order[i].custom){
                            this.order[i].name = event.target.value
                      }
                  }
              },
              onRemove(id) {
                console.log(this.orderForm)
                console.log("firing from on onRemove - id is: " + id)
                let newView = []
                for(let i = 0; i < this.orderForm.length; i++){
                    if(this.orderForm[i].custom != id) {
                        newView.push(this.orderForm[i])
                    }
                }

                this.orderForm = newView

                let output = []
                for(let j = 0; j < this.order.length; j++){
                    console.log(id)
                    if(this.order[j].custom != id) {
                        output.push(this.order[j])
                    }
                }
                this.order = output
              },
              createDetails(item){
                console.log('what is happening: ' + item)
                this.modalAdditionalInfo = 1
                this.currentItem = item
                console.log('add a link to the current order row for: ' + item.custom)
              },
              addDetails(item, event, subject){
                console.log("Item is: " + item)
                console.log(item);
                if(this.order.length < 1){
                  if(this.$store.state.shoppingCart.length < 1){
                    this.order = []
                  } else {
                  this.order = this.$store.state.shoppingCart
                  }
                }
                if (subject ===  'link'){
                    for(let i = 0; i < this.order.length; i++) {
                        if(item.custom === this.order[i].custom) {
                            this.order[i].productLink = event.target.value
                            this.currentItem.productLink = event.target.value
                        }
                    }
                } else if (subject === 'manu'){
                    for(let i = 0; i < this.order.length; i++) {
                        if(item.custom === this.order[i].custom) {
                            this.order[i].manufacturer = event.target.value
                            this.currentItem.manufacturer = event.target.value
                        }
                    }
                } else if (subject === 'part'){
                    for(let i = 0; i < this.order.length; i++) {
                        if(item.custom === this.order[i].custom) {
                            this.order[i].part = event.target.value
                            this.currentItem.part = event.target.value
                        }
                    }                  
                } else if (subject === 'comment'){
                    for(let i = 0; i < this.order.length; i++) {
                        if(item.custom === this.order[i].custom) {
                            this.order[i].comment = event.target.value
                            this.currentItem.comment = event.target.value
                        }
                    }                  
                }
              },
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              getInventory() {
                this.allStock = []
                this.searchTable = {}
                this.searchNames = []
                this.allStock = []
                this.stockTable = {}
                this.stock = []
                this.$store.dispatch('getInventory').then(res => {
                  for(let i = 0; i < res.length; i++){
                    if(res[i]){
                      this.searchTable[(res[i].name.toLowerCase())] = res[i]
                      this.searchNames.push(res[i].name.toLowerCase())
                      this.allStock.push(res[i])
                      this.stockTable[res[i].name] = (res[i].necessary_amount + 1) - res[i].quantity
                    }
                  }
                  this.stock = this.allStock.sort(this.sortItems)
                })
              },
////////////////////////////////////////////////// Shopping Cart Functions ////////////////////////////////////////////////////////////////
            showCart(){
                console.log("View Cart")
                console.log("this is from session storage")
                console.log(sessionStorage.getItem("order"))
                console.log(this.$store.state.shoppingCart === null)
                console.log(this.$store.state.shoppingCart)
                let refreshCheck = 1
                if(this.$store.state.shoppingCart === null || this.$store.state.shoppingCart.length < 1){
                  console.log("it's null")
                  refreshCheck = 0
                }
                if(!refreshCheck){
                  console.log("Nothing in cart!")
                  this.$store.state.shoppingCart = JSON.parse(decodeURI(sessionStorage.getItem("order")))
                }
                this.modal2 = 1
                this.modal3 = 1
                let dict = {}
                this.$store.dispatch('getLastOrder').then(res => {
                  // console.log(res)
                  // this.prevOrder =JSON.parse(decodeURI(res[0].orderInfo))
                  // console.log(this.prevOrder)
                  let result = JSON.parse(decodeURI(res[0].orderInfo))
                  for(let i = 0; i < result.length; i++){
                    let cur = result[i]
                    dict[cur.name] = cur
                  }
                  // console.log(dict)
                  if(this.checkPrev(dict)){
                    this.doubleAlert = 1
                  }
                })
            },
            checkPrev(order){
              let output = []
              if(this.$store.state.shoppingCart){
                  for(let i = 0; i < this.$store.state.shoppingCart.length; i++){
                      let cur = this.$store.state.shoppingCart[i]
                      if(order[cur.name]){
                        output.push(order[cur.name])
                      }
                  }
                  if(output.length >= 1) {
                    this.prevOrder = output
                    return 1
                  } else {
                    return 0
                  }
              }
            },
            editCart(){
                this.modal4 = 1
                this.modal3 = 0
                this.modal5 = 0
                let curCart = []
                if(!this.editFlag){
                    this.editFlag = 1
                    if(this.$store.state.shoppingCart){
                        curCart = this.$store.state.shoppingCart
                    }
                    for(let i = 0; i < curCart.length; i++){
                       this.orderForm.push(curCart[i])
                    }
                }
                // console.log(this.orderForm)
            },
            clearCart(){
                this.$store.commit('removeItems', this.$store.state.shoppingCart.length)
                sessionStorage.clear()
                this.modal2 = 0
                this.modal3 = 0
                this.modal4 = 0
                this.msg = ''
                this.dupCheck = {}
            },
            updateCart(){
                let commit = 1
                let curCart = []
                if(this.$store.state.shoppingCart){
                  curCart = this.$store.state.shoppingCart
                }
                let missing = []
                // this.$store.commit('removeItems', curCart.length)
                // let order = this.$store.state.shoppingCart
                // console.log('order: ' + order)
                for(let i = 0; i < this.orderForm.length; i++){
                    let cur = this.orderForm[i]
                    console.log(cur)
                    if(!cur.amount){
                      missing.push(cur.name)
                      commit = 0
                      this.msg = "Please insert an amount for: " + missing
                      break
                    } 
                    // else if (cur.isCustom && cur.comment.length < 3){
                    //   missing.push(cur.name)
                    //   commit = 0
                    //   this.msg = "Please include a description in the comments (link, details, etc.) for: " + missing
                    //   break
                    // }
                }
                this.$store.state.shoppingCart = []
                if (commit){
                  for(let j = 0; j < this.orderForm.length;j++){
                      this.$store.commit('addItems', this.orderForm[j])
                  }
                  let body = ''
                  body = JSON.stringify(this.$store.state.shoppingCart)
                  body = encodeURI(body)
                  sessionStorage.clear()
                  sessionStorage.setItem("order", body);
                  this.modal3 = 1
                  this.modal4 = 0
                  this.orderForm = []
                  this.editFlag = 0
                  console.log(curCart)
                } 
            },
            submitCart(e){
                e.preventDefault()
                this.modal5 = 1
                this.modal3 = 0
                console.log("Flags are: " + this.modal2 + this.modal3 + this.modal4)
                this.handleSubmit(e)
                this.finalSub = 1
            },
            addToCart(){
                this.dupAlert = []
                this.alertDup = 0
                let commit = 1
                let missing = []
                let curCart = []
                if(this.$store.state.shoppingCart === null || this.$store.state.shoppingCart.length < 1){
                  console.log("it's null")
                } else {
                    curCart = this.$store.state.shoppingCart
                }
                for (let i = 0; i < curCart.length;i++){
                    if(!this.dupCheck[curCart[i].name]){
                      this.dupCheck[curCart[i].name] = true
                    }
                }
                console.log(curCart)
                for (let i = 0; i < curCart.length;i++){
                    if(!this.dupCheck[curCart[i].name]){
                      this.dupCheck[curCart[i].name] = true
                    }
                }

                // scan through and make sure there aren't any items that have not amounts attached
                for(let i = 0; i < this.order.length; i++){
                    if(!this.order[i].amount){
                      missing.push(this.order[i].name)
                      commit = 0
                      this.msg = "Please insert an amount for: " + missing
                      break
                    } else if (this.order[i].isCustom && this.order[i].comment.length < 3){
                      missing.push(this.order[i].name)
                      commit = 0
                      this.msg = "Please include a description in the comments (link, details, etc.) for: " + missing
                      break
                    }
                }
                if(!commit){
                    console.log("Add to cart did not go through")
                }

                if (commit){
                    for(let i = 0; i < this.order.length;i++){
                        if(!this.dupCheck[this.order[i].name]){
                            this.$store.commit('addItems', this.order[i])
                            this.dupCheck[this.order[i].name] = true
                        }
                        else {
                            this.dupAlert.push(this.order[i].name)
                            this.alertDup = 1
                        }
                    }
                    this.flag2 = 0
                    this.flag5 = 1
                    this.orderForm = []
                    this.order = []
                    this.msg = ''
                    let body = '';
                    body = JSON.stringify(this.$store.state.shoppingCart)
                    body = encodeURI(body)
                    sessionStorage.setItem("order", body);
                    setTimeout(() => this.flag1 = 1 ,  2000);
                }
            },
            closeCart(){
                if(this.finalSub){
                  this.clearCart()
                  this.finalSub = 0
                }
                this.modal2 = 0
                this.modal3 = 0
                this.modal4 = 0
                this.modal5 = 0
                this.orderForm = []
                this.editFlag = 0
            },
            // Submit order form
            handleSubmit(e){
              e.preventDefault()
              let order = this.$store.state.shoppingCart
              let output = {}
              if(this.emergencyFlag){
                // mark that it is an emergency run
                output.status = -1
              } else {
                output.status = 0
              }
              output.order = this.$store.state.shoppingCart
              // console.log(order)
              console.log("In handle submit - this is the order info")
              console.log(order)
              for(let i = 0; i < order.length; i++){
                  if(order[i].isCustom){
                    if(!this.searchTable[order[i].name.toLowerCase()]){
                      this.customItems.push(order[i])
                      this.customItemFlag = 1
                    } else {
                      console.log("this item is already in the inventory: " + order[i])
                    }
                  }
                  
                  if(order[i].ADSitem){
                    if(!this.searchTable[order[i].name.toLowerCase()]){
                      this.customItems.push(order[i])
                      this.customItemFlag = 1
                    } else {
                      console.log("this item is already in the inventory: " + order[i])
                    }
                  }
              }
              console.log(this.customItems)
              // this.$store.commit('removeItems', this.$store.state.shoppingCart.length)
              // sessionStorage.clear()
              // console.log(custom)
              ////////////////// Add All Custom Items to Folder for Adding to ADSInventory ////////////////////
              this.$store.dispatch('logOrder', output).then(res => {
              // add custom items to inventory
                  this.$store.dispatch('storeCustomItems', this.customItems)
                  // this.$store.commit('removeItems', this.$store.state.shoppingCart.length)
                  // sessionStorage.clear()
              })
            },
            resetCartView() {
                this.flag1 = 1
                this.dupAlert = []
                this.alertDup = 0
                this.msg = ''
            },
            onChangeCart(str, event){
                  if(event.target.value < 1){
                    this.msg = "Please input a valid amount " + str
                  }
                  else {
                    this.msg = ''
                    for (let i = 0; i < this.orderForm.length; i++){
                          if(this.orderForm[i].name === str){
                            this.orderForm[i].amount = event.target.value
                        }
                    }
                }
            },
            onTextChangeCart(str, event){
                for (let i = 0; i < this.orderForm.length; i++){
                      if(this.orderForm[i].name === str){
                        this.orderForm[i].comment = event.target.value
                    }
                }
            },
            onCustomChangeCart(id, event) {
                event.preventDefault()
                console.log("item id is: " + id)
                for (let i = 0; i < this.orderForm.length; i++) {
                    if(id === this.orderForm[i].custom){
                          this.orderForm[i].name = event.target.value
                    }
                }
            },
/////////////////////////////////////////////////////////// Wizard Functions /////////////////////////////////////////////////
            removeFromOrder(){
              console.log("in remove from order")
              // console.log(this.prevOrder)
              // console.log(this.shoppingCart)
              // console.log(this.cancelForm)
              let actFlag = 0
             
              if(this.cancelForm.length >= 1){
                console.log(this.cancelForm)
                for(let i = 0; i < this.cancelForm.length; i++){
                    this.cancelDict[this.cancelForm[i].name] = this.cancelForm[i]
                    actFlag = 1
                }
              }
              // console.log(this.cancelDict)
              let output = []
              if(actFlag){
                for(let i = 0; i < this.$store.state.shoppingCart.length; i++){
                  let cur = this.$store.state.shoppingCart[i]
                  if(!this.cancelDict[cur.name]){
                    output.push(cur)
                  }
                }
                this.$store.state.shoppingCart = output
                this.doubleAlert = 0
              } else {
                console.log("nothing has been selected")
              }
            },
            fbAddInventory(){
                console.log("inside fbAddInventory")
                // console.log(this.customForm)
                let temp = []
                temp = this.customForm
                console.log(temp)
                this.$store.dispatch('createCustom', temp).then( res => {
                  this.closeCart()
                })
            },
            cancelAddInventory(){
              this.customForm = ''
              this.closeCart()
            },
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            onDecode (result) {
              this.result = result
            },

            async onInit (promise) {
              try {
                await promise
              } catch (error) {
                if (error.name === 'NotAllowedError') {
                  this.error = "ERROR: you need to grant camera access permisson"
                } else if (error.name === 'NotFoundError') {
                  this.error = "ERROR: no camera on this device"
                } else if (error.name === 'NotSupportedError') {
                  this.error = "ERROR: secure context required (HTTPS, localhost)"
                } else if (error.name === 'NotReadableError') {
                  this.error = "ERROR: is the camera already in use?"
                } else if (error.name === 'OverconstrainedError') {
                  this.error = "ERROR: installed cameras are not suitable"
                } else if (error.name === 'StreamApiNotSupportedError') {
                  this.error = "ERROR: Stream API is not supported in this browser"
                }
              }
            }
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    table, th, td {
      border: 1px solid #DFDFDF;
      padding: 2px;
    }

    table {
        border-collapse: collapse;
        margin-left:auto;
        margin-right:auto;
    }  
    h1, h2 {
        font-weight: normal;
    }
    ul {
        list-style-type: none;
        padding: 0;
    }
    li {
        display: inline-block;
        margin: 0 10px;
    }
    a {
      color: #07ABA1;
      font-size: 1.5em;
    }

    button {
      padding: 1%;
      font-size: 1em;
      background-color: #07ABA1;
      color: #FFF;
      border-radius: 2px;
      border: none;
      cursor: pointer;
      outline: none;
      box-shadow: none;
    }

    .navlink {
        padding-right: 25px;
        font-size: 1.5em;
        text-decoration: none;
    }

    .control {
      width: 150px;
      height: 100px;
      background-color: #07ABA1;
      margin: 5px 5px 5px 5px;
      text-decoration : none;
      color: #FFF;
      font-size: 1.5rem;
      cursor: pointer;
    }

    .timeDisplay {
      margin-top: 0px;
      margin-bottom: 0px;
      padding-top: 0px;
      padding-bottom: 0px;
      font-size: 72px;
    }
    .cancelButton {
      background-color: #07ABA1;
      color: #FFF; 
      float: left; 
      padding-right: 2%;
      font-size: 1.4em;
      font-weight: 1200;
      border-radius: 0px;
    }

/* Modal CSS */

    .modal-mask {
      position: fixed;
      z-index: 9998;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
      display: table;
      transition: opacity 0.3s ease;
    }
    .modal-wrapper {
      display: table-cell;
      vertical-align: middle;
    }
    .modal-container {
      width: 1000px;
      height: 500px;
      margin: 0px auto;
      background-color: #fff;
      border-radius: 2px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
      transition: all 0.3s ease;
      overflow-y: scroll;
      padding-bottom: 2%;
    }
    .modal-header h3 {
      margin-top: 0;
      color: #42b983;
    }
    .modal-body {
      margin: 20px 0;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
    .modal-default-button {
      margin: 5px;
    }
    .modal-banner {
      margin: 0px;
      padding: 0px; 
      background-color: #07ABA1; 
      width: 100%;
      font-size: 2em;
      color: #FFF;

    }
    .cancelButton {
      background-color: #07ABA1;
      color: #FFF; 
      float: left; 
      padding-right: 2%;
      font-size: 1.4em;
      font-weight: 1200;
      border-radius: 0px;
    }

    /* Transition CSS */

    .fade-enter-active, .fade-leave-active {
      transition-property: opacity;
      transition-duration: .15s;
    }

    .fade-enter-active {
      transition-delay: .15s;
    }

    .fade-enter, .fade-leave-active {
      opacity: 0;
    }

    .modal-enter {
      opacity: 0;
    }       

    .modal-leave-active {
      opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
      -webkit-transform: scale(1.1);
      transform: scale(1.1);
    }
    /*                form test                       */
    .form-style-7{
      max-width:400px;
      margin:50px auto;
      background:#fff;
      border-radius:2px;
      padding:20px;
    }
    .form-style-7 h1{
      display: block;
      text-align: center;
      padding: 0;
      margin: 0px 0px 20px 0px;
      color: #5C5C5C;
      font-size:x-large;
    }
    .form-style-7 ul{
      list-style:none;
      padding:0;
      margin:0;	
    }
    .form-style-7 li{
      display: block;
      padding: 9px;
      border:1px solid #DDDDDD;
      margin-bottom: 30px;
      border-radius: 3px;
    }
    .form-style-7 li:last-child{
      border:none;
      margin-bottom: 0px;
      text-align: center;
    }
    .form-style-7 li > label{
      display: block;
      float: left;
      margin-top: -19px;
      background: #FFFFFF;
      height: 14px;
      padding: 2px 5px 2px 5px;
      color: #B9B9B9;
      font-size: 14px;
      overflow: hidden;
    }
    .form-style-7 input[type="text"],
    .form-style-7 input[type="date"],
    .form-style-7 input[type="datetime"],
    .form-style-7 input[type="email"],
    .form-style-7 input[type="number"],
    .form-style-7 input[type="search"],
    .form-style-7 input[type="time"],
    .form-style-7 input[type="url"],
    .form-style-7 input[type="password"],
    .form-style-7 textarea,
    .form-style-7 select 
    {
      box-sizing: border-box;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      width: 100%;
      display: block;
      outline: none;
      border: none;
      height: 25px;
      line-height: 25px;
      font-size: 16px;
      padding: 0;
    }
    .form-style-7 input[type="text"]:focus,
    .form-style-7 input[type="date"]:focus,
    .form-style-7 input[type="datetime"]:focus,
    .form-style-7 input[type="email"]:focus,
    .form-style-7 input[type="number"]:focus,
    .form-style-7 input[type="search"]:focus,
    .form-style-7 input[type="time"]:focus,
    .form-style-7 input[type="url"]:focus,
    .form-style-7 input[type="password"]:focus,
    .form-style-7 textarea:focus,
    .form-style-7 select:focus 
    {
    }
    .form-style-7 li > span{
      background: #F3F3F3;
      display: block;
      padding: 3px;
      margin: 0 -9px -9px -9px;
      text-align: center;
      color: #C0C0C0;
      font-size: 11px;
    }
    .form-style-7 textarea{
      resize:none;
    }
    .form-style-7 input[type="submit"],
    .form-style-7 input[type="button"]{
      background: #2471FF;
      border: none;
      padding: 10px 20px 10px 20px;
      border-bottom: 3px solid #5994FF;
      border-radius: 3px;
      color: #D2E2FF;
    }
    .form-style-7 input[type="submit"]:hover,
    .form-style-7 input[type="button"]:hover{
      background: #6B9FFF;
      color:#fff;
    }

    .speech-bubble {
	    position: relative;
	    background: #d9dddd;
	    border-radius: .4em;
      width: 200px;
      height: 100px;
      transform: rotate(12deg)
    }

    .speech-bubble:after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 50%;
      width: 0;
      height: 0;
      border: 32px solid transparent;
      border-top-color: #d9dddd;
      border-bottom: 0;
      border-left: 0;
      margin-left: -92px;
      margin-bottom: -20px;
    }
</style>
